<template>
  <QItem clickable @click="handleAction">
    <QItemSection avatar>
      <QIcon :name="icon" :color="iconColor" />
    </QItemSection>
    <QItemSection>{{ label }}</QItemSection>
    <QChip v-if="displayChip" class="chip" :label="t('CORE.@NEW')" color="secondary" text-color="white" size="sm" />
  </QItem>
</template>

<script setup>
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();
  const emit = defineEmits(["on-action"]);

  const props = defineProps({
    icon: {
      type: String,
      required: true,
    },
    iconColor: {
      type: String,
      default: "faded",
    },
    label: {
      type: String,
      required: true,
    },
    displayChip: {
      type: Boolean,
      default: false,
    },
  });

  const handleAction = () => {
    emit("on-action");
  };
</script>
<style lang="scss" scoped>
  .chip {
    position: absolute;
    top: -13px;
    right: 13px;
  }
</style>
